module.exports = __webpack_public_path__ + "static/media/tutorial-wounds.d8817e68.png";